import { createAction, props } from '@ngrx/store';
import { Note } from '../_models';

// Action types
export const loadNotes = createAction('[Note] Load Notes');
export const loadNotesSuccess = createAction(
  '[Note] Load Notes Success',
  props<{ notes: Note[] }>()
);
export const loadNotesFailure = createAction('[Note] Load Notes Failure', props<{ error: any }>());

export const addNote = createAction('[Note] Add Note', props<{ note: Note }>());
export const addNoteSuccess = createAction('[Note] Add Note Success', props<{ note: Note }>());
export const addNoteFailure = createAction('[Note] Add Note Failure', props<{ error: any }>());

export const updateNote = createAction('[Note] Update Note', props<{ note: Note }>());
export const updateNoteSuccess = createAction(
  '[Note] Update Note Success',
  props<{ note: Note }>()
);
export const updateNoteFailure = createAction(
  '[Note] Update Note Failure',
  props<{ error: any }>()
);

export const deleteNote = createAction('[Note] Delete Note', props<{ id: number }>());
export const deleteNoteSuccess = createAction(
  '[Note] Delete Note Success',
  props<{ id: number }>()
);
export const deleteNoteFailure = createAction(
  '[Note] Delete Note Failure',
  props<{ error: any }>()
);
